import { useEffect, useState } from "react";
import type { ActiveFilters } from "./DataTableTypes";
import { pageWindow, type PageWindow } from "./paging";

export interface Paging extends PageWindow {
  setPage: (page: number) => void;
}

/** What, when it changes, sends the table back to the first page. */
export interface PagingResetTriggers {
  query: string;
  filters: ActiveFilters;
}

export function usePaging(itemCount: number, pageSize: number, resetOn: PagingResetTriggers): Paging {
  const [page, setPage] = useState(1);
  const { query, filters } = resetOn;

  useEffect(() => {
    setPage(1);
  }, [query, filters, pageSize]);

  return { ...pageWindow(itemCount, pageSize, page), setPage };
}
